import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";
import { formatCurrencyAmount, isValidAmount } from "../../../utils/helper";
import { formatReserveAmount } from "./ReserveBreakdownModal";
import "../styles/analytics.scss";

export function formatKpiAmount(value, currency) {
  const formatted = formatCurrencyAmount(value);
  if (formatted === "-" || formatted === "--") return formatted;
  return currency ? `${currency} ${formatted}` : `$${formatted}`;
}

const ClaimRecoveryKpiPanel = ({ chartRef, displayOptions, chartHeightPx, kpis }) => (
  <Box className="claim-recovery-kpi-layout">
    <ReactECharts
      ref={chartRef}
      option={{
        ...displayOptions,
        legend: { show: true, orient: "horizontal", left: "center", bottom: 4, icon: "circle", itemWidth: 13, itemHeight: 13, itemGap: 20, textStyle: { fontSize: 15 }, },
        series: (displayOptions?.series || []).map((s) => s?.type === "pie" ? { ...s, center: ["50%", "44%"], radius: ["48%", "68%"] } : s, ),
      }}
      style={{ height: chartHeightPx, width: "65%", flexShrink: 0 }}
      notMerge={true}
      lazyUpdate={false}
    />
    <Box className="claim-recovery-kpi-panel">
      <Box className="claim-recovery-kpi-panel__rate">
        {isValidAmount(kpis?.recovery_pct)
          ? `${formatReserveAmount(kpis.recovery_pct).replace(/\.00$/, "")}%`
          : "-"}
      </Box>
      <Box className="claim-recovery-kpi-panel__rate-label">Recovery Rate</Box>
      {[
        { label: "Claims Raised", value: kpis?.claim_amount },
        { label: "Recovered", value: kpis?.amount_paid },
        { label: "Outstanding", value: kpis?.outstanding },
      ].map((item) => (
        <Box key={item.label} className="claim-recovery-kpi-panel__row">
          <span className="claim-recovery-kpi-panel__row-label">{item.label}</span>
          <span className="claim-recovery-kpi-panel__row-value">
            {formatKpiAmount(item.value, kpis?.currency)}
          </span>
        </Box>
      ))}
    </Box>
  </Box>
);

export default ClaimRecoveryKpiPanel;
